import { statement } from "@babel/template";
import Card from '@material-ui/Core/Card'
import React, { Component } from 'react'
import TextField from '@material-ui/Core/TextField'
import Button from '@material-ui/Core/Button'
import FormControl from '@material-ui/Core/FormControl'
import InputLabel from '@material-ui/Core/InputLabel'
import Select from '@material-ui/Core/Select'
import MenuItem from '@material-ui/Core/MenuItem'
import { CardActions, CardHeader, Grid } from "@material-ui/Core";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";


import Script from 'react-load-script';

class AddressInfo extends Component {
    constructor(props){
        super(props);
        this.state = {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            address1Error: false,
            address2Error: false,
            cityError: false,
            stateError: false,
            zipError: false,
            isLoading: false,
            canSubmit: false,
            address: '',
            query: '',
            disabledForTyping: false
        }

        this.handleAddressLine1Change = this.handleAddressLine1Change.bind(this)
        this.handleAddressLine2Change = this.handleAddressLine2Change.bind(this)
        this.handleCityChange = this.handleCityChange.bind(this)
        this.handleStateChange = this.handleStateChange.bind(this)
        this.handleZipChange = this.handleZipChange.bind(this)

        this.handleSubmit = this.handleSubmit.bind(this)
        this.onKeyDown = this.onKeyDown.bind(this)
        
        this.validateZip = this.validateZip.bind(this)
    }

    handleScriptLoad = () => {
        // Declare Options For Autocomplete
        let type = ''
        let autocomplete = ''
        if(this.props.requirements.AddressStreetVisible == "1"){
            type = 'address'
            autocomplete = 'address1'
        }else if(this.props.requirements.AddressCityVisible == "1"){
            type = '(regions)'
            autocomplete = 'city'
        }else if(this.props.requirements.AddressStateVisible == "1"){
            type = '(regions)'
            autocomplete = 'state'
        } else {
            type = '(regions)'
            autocomplete = 'postal-code'
        }
        

        const options = {
          types: type,
        };
    
        // Initialize Google Autocomplete
        /*global google*/ // To disable any eslint 'google not defined' errors
        this.autocomplete = new google.maps.places.Autocomplete(
          document.getElementById(autocomplete),
          options,
        );
    
        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components and formatted
        // address.
        this.autocomplete.setFields(['address_components', 'formatted_address']);
    
        //set country codes
        this.autocomplete.setComponentRestrictions({
            country: this.props.countryList.length ? this.props.countryList.split(',') : ["us", "pr", "vi", "gu", "mp"],
          });
    
        // Fire Event when a suggested name is selected
        this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
      }
      
      handlePlaceSelect = () => {
    
        // Extract City From Address Object
        const addressObject = this.autocomplete.getPlace();
        const address = addressObject.address_components;

        // Reset the state on new place select.

        this.setState({
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: ''
        })

        // Some addresses do not have a city attached to them- but instead a township, county, parish, etc. In these instances, we first check
        // if the given address does have a city- if it does not, we insert the 'administrative_area_level_3' into the city field- 
        // these values such as 'Wayne Township', 'Bruce Township', 'Kitsap County', etc essentially function as the city in these addresses. 
        let addressHasCity = false;

        // Check if address is valid
        let streetnumber, route; 
        if (address) {
            //cycle through the returned adddress components and set those needed
            address.forEach(address => {
                switch(address.types[0]){
                    case 'locality':
                        this.setState({
                            city: address.long_name
                        })
                        addressHasCity = true;
                        break;
                    case 'administrative_area_level_1':
                        this.setState({
                            state:address.short_name
                        })
                        break;
                    case 'administrative_area_level_3':
                        if (!addressHasCity) {
                            this.setState({
                                city: address.long_name
                            })
                        }
                        break;
                    case 'street_number':
                        streetnumber = address.long_name
                        break;
                    case 'route':
                        route = address.short_name
                        break;
                    case 'postal_code':
                        this.setState({
                            zip: address.long_name
                        })
                        break;
                    default:
                        break;
                }
            })
            if(streetnumber && route && streetnumber.length && route.length){
                this.setState({
                    address1: streetnumber + ' ' + route
                })
            }

            this.setState({disabledForTyping: true})

          // Set State
          /*this.setState(
            {
              address: address,
              query: addressObject.formatted_address,
              address1:address[0].long_name + " " + address[1].long_name,
              city: address[3].long_name,
              state: address[5].short_name,
              zip: address[7].long_name
            }
          ); */
        }
      }

    handleAddressLine1Change(event) {
        if(!event.target.value.match(/[!@$%^&*(),?":{}|<>]/g)){
            this.setState({ address1: event.target.value, address1Error: false})
            //this.checkSubmit(true)
        }
        else if(!event.target.value.length){
            this.setState({ address1: "", address1Error: false})
        }
        else{
            this.setState({ address1Error: true})
            //this.checkSubmit(true)
        }

    }
    handleAddressLine2Change(event) {
        if(!event.target.value.match(/[!@$%^&*(),?":{}|<>]/g)){
            this.setState({ address2: event.target.value, address2Error: false})
        }
        else if(!event.target.value.length){
            this.setState({ address2: "", address2Error: false})
        }
        else{
            this.setState({address2Error: true})
        }
    }
    handleCityChange(event) {
        if(!event.target.value.length || !event.target.value.match(/[0-9!@$%^&*(),?":{}|<>]/g)){
            this.setState({ city: event.target.value, cityError: false})
        }
        else if(!event.target.value.length){
            this.setState({ city: "", cityError: false})
        }
        else{
            this.setState({cityError: true})
        }
    }
    handleStateChange(event) {
        if(!event.target.value.match(/[0-9!@$%^&*(),?":{}|<>]/g)){
            this.setState({ state: event.target.value, stateError: false})
        } 
        else if(!event.target.value.length){
            this.setState({ state: "", stateError: false})
        }
        else{
            this.setState({stateError: true})
        }
    }
    handleZipChange(event) {
        if(event.target.value){
            this.setState({ zip: event.target.value, zipError: false})
        }
        else if(!event.target.value.length){
            this.setState({ zip: "", zipError: false})
        }
        else{
            this.setState({zipError: true})
        }
        
    }

    validateZip(){
        if(this.state.zip.length && !this.state.zip.match(/^\d{5}(?:[-\s]\d{4})?$/g)){
            this.setState({
                zipError: true
            })
        }
    }

    //checkSubmit(hasErrors){
    //    //if the last update has errors
    //    //and can currently submit
    //    if(hasErrors && !this.state.canSubmit){
    //        this.setState({
    //            canSubmit: false
    //        })
    //    }
    //    //if all required fields are valid
    //    //currently all fields except address2 are required
    //    if(){
//
    //    }
//
    //}

    handleSubmit() {
        let hasErrors = false;

        if(this.state.address1Error || this.state.cityError || this.state.stateError || this.state.zipError){
            hasErrors = true
        }

        if((!this.state.address1.length || this.state.address1 =='~~')  && this.props.requirements.AddressStreetRequired == "1"){
            hasErrors = true
            
            this.setState({
                address1Error:true
            })
        }

        if((!this.state.city.length || this.state.city =='~~')  && this.props.requirements.AddressCityRequired == "1"){
            hasErrors = true
            
            if(!this.state.city.length){
                this.setState({city: "~~"})
            }
            this.setState({
                cityError:true
            })
        }

        if((!this.state.state.length || this.state.state =='~~') && this.props.requirements.AddressStateRequired == "1"){
            hasErrors = true
            this.setState({
                stateError:true
            })
        }

        if((!this.state.zip.length || this.state.zip =='~~')  && this.props.requirements.ZipRequired == "1"){
            hasErrors = true
            this.setState({
                zipError:true
            })
        }

        if(!hasErrors){
            this.setState({
                isLoading:true
            })

            let address = this.state.address1.length ? encodeURIComponent(this.state.address1) : "~~"
            let address2 = this.state.address2.length ? encodeURIComponent(this.state.address2) : "~~"
            let city = this.state.city.length ? encodeURIComponent(this.state.city) : "~~"
            let state = this.state.state.length ? encodeURIComponent(this.state.state) : "~~"
            let zip = this.state.zip.length ? encodeURIComponent(this.state.zip) : "~~"

            fetch('../../WsWebServicePlatform/Participant/Address/Create/' +
                this.props.authtoken + '/' +
                this.props.participantguid + '/' +
                '90899741-5728-4F9C-A489-691131304962/1/' +
                address + '/' + 
                address2 + '/' +
                '~~' + '/' +
                city + '/' +
                state + '/' +
                zip  + '/' +
                'USA/',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                
                }
            })
            .then(results=>results.json())
            .then(results=>{
                console.log("show results")
                this.props.showresults();
                
            })
            .catch((error) => {
                console.log("Failed to save address")
                this.props.showresults();
            })
        }
    }

    onKeyDown(e) {
        //if an address has been selected, prevent typing
        if(this.state.disabledForTyping){
            console.log("prevented", e)
             e.preventDefault();
        }
    }

    render() {
        // Set the language ISO key in the URL. This allows Google's API to return values in the appropriate language.
        var languageISO2 = this.props.languageISO2
        var url = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBt491P6Oq_NBxC0mexUlLxuh5dEpryDA4&libraries=places&language="+languageISO2;

        let icon = null;
        if(this.state.isLoading){
            icon = <img src="loading.gif" width='20px' style={{marginLeft: '4px'}}/>
        } else {
            icon = <NavigateNextIcon />
        }

        var address1, address2, city, state, zip
        if(this.props.requirements.AddressStreetVisible == "1"){
            address1 = <TextField 
                            id="address1"
                            label={this.props.viewInstance.Street1Label}
                            variant="outlined"
                            margin="normal"     
                            autoFocus
                            autocomplete="off"
                            required={this.props.requirements.AddressStreetRequired == "1"}
                            visible={this.props.requirements.AddressStreetVisible == "1"}
                            onChange={this.handleAddressLine1Change}
                            error={this.state.address1Error}    
                            value={this.state.address1}
                        />
        }
        if(this.props.requirements.AddressStreetVisible == "1"){
            address2 = <TextField
                            id="address2"
                            label={this.props.viewInstance.Street2Label}
                            variant="outlined"
                            margin="normal"    
                            visible={this.props.requirements.AddressStreetVisible == "1"}
                            onChange={this.handleAddressLine2Change}
                        />
        }
        if(this.props.requirements.AddressCityVisible == "1"){
            city = <TextField
                            id="city"
                            label={this.props.viewInstance.CityLabel}
                            variant="outlined"
                            margin="normal"   
                            required={this.props.requirements.AddressCityRequired == "1"}
                            visible={this.props.requirements.AddressCityVisible == "1"}
                            onChange={this.handleCityChange}
                            error={this.state.cityError}
                            value={this.state.city}
                        />
        }                
        if(this.props.requirements.AddressStateVisible == "1"){
            state = <TextField
                        id="state"
                        label={this.props.viewInstance.StateLabel}
                        variant="outlined"
                        margin="normal"  
                        inputProps={{maxLength: 2}}
                        required={this.props.requirements.AddressStateRequired == "1"}
                        visible={this.props.requirements.AddressStateVisible == "1"}
                        onChange={this.handleStateChange}
                        error={this.state.stateError}
                        value={this.state.state}
                        onKeyDown={this.onKeyDown}
                    />
        }                
        if(this.props.requirements.ZipVisible == "1"){
            zip = <TextField
                        id="postal-code"
                        label={this.props.viewInstance.ZipLabel}
                        variant="outlined"
                        margin="normal" 
                        required={this.props.requirements.ZipRequired == "1"}
                        visible={this.props.requirements.ZipVisible == "1"}
                        onChange={this.handleZipChange}
                        error={this.state.zipError}
                        value={this.state.zip}
                        onBlur={this.validateZip}
                    />
        }                
                        

        return (
            
            <Card raised="true">
                <Script
          url={url}
          onLoad={this.handleScriptLoad}
        />
                <CardHeader title={this.props.viewInstance.CardTitle} />
                <CardActions>
                    <Grid container
                        direction="column"
                        justify="space-around"
                        alignItems="stretch">
                        {address1}
                        {address2}
                        {city}
                        {state}
                        {zip}
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={this.handleSubmit}>{this.props.viewInstance.ButtonLabel} {icon}</Button>
                    </Grid>
                </CardActions>
            </Card>
        )
    }
}

// Import React Scrit Libraray to load Google object

class Search extends Component {
  // Define Constructor
  constructor(props) {
    super(props);

    // Declare State
    this.state = {
      city: '',
      query: ''
    };

  }



  render() {
    return (
      <div>
        
        <TextField id="autocomplete" placeholder="" hintText="Search City" value={this.state.query}
          style={{
            margin: '0 auto',
            maxWidth: 800,
          }}
        />
      </div>
    );
  }
}

export default AddressInfo;